export const data = {
  sunday: {
    num: 0,
    name: 'Sunday',
    portugueseName: 'Domingo',
    active: false,
    workTime: [{
      start: '08:30',
      end: '18:00'
    }
    ]
  },
  monday: {
    num: 1,
    name: 'Monday',
    portugueseName: 'Segunda',
    active: true,
    workTime: [{
      start: '08:30',
      end: '12:00'
    },
    {
      start: '13:00',
      end: '18:00'
    }
    ]
  },
  tuesday: {
    num: 2,
    name: 'Tuesday',
    portugueseName: 'Terça',
    active: true,
    workTime: [{
      start: '08:30',
      end: '18:00'
    }]
  },
  wednesday: {
    num: 3,
    name: 'Wednesday',
    portugueseName: 'Quarta',
    active: true,
    workTime: [{
      start: '08:30',
      end: '12:00'
    },
    {
      start: '13:00',
      end: '18:00'
    }
    ]
  },
  thursday: {
    num: 4,
    name: 'Thursday',
    portugueseName: 'Quinta',
    active: true,
    workTime: [{
      start: '08:30',
      end: '18:00'
    }]
  },
  friday: {
    num: 5,
    name: 'Friday',
    portugueseName: 'Sexta',
    active: true,
    workTime: [{
      start: '08:30',
      end: '18:00'
    }]
  },
  saturday: {
    num: 6,
    name: 'Saturday',
    portugueseName: 'Sábado',
    active: true,
    workTime: [{
      start: '08:30',
      end: '12:00'
    }]
  }
}